// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".about-menu_about-icon_j1OTV {\n    height: 1.25rem;\n    margin: 0.5rem;\n    vertical-align: middle;\n}\n", "",{"version":3,"sources":["webpack://./src/components/menu-bar/about-menu.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B","sourcesContent":[".about-icon {\n    height: 1.25rem;\n    margin: 0.5rem;\n    vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"about-icon": "about-menu_about-icon_j1OTV",
	"aboutIcon": "about-menu_about-icon_j1OTV"
};
module.exports = ___CSS_LOADER_EXPORT___;
